export const schema = {
  action: {
    copyField: "Copy field",
    deleteField: "Delete field",
    editField: "Edit field",
    previewField: "Preview",
  },
  fieldType: {
    assetUnlockToggler: "Identified Asset (NFC, QR, …)",
    checkbox: "Checkbox",
    defects: "Defects select",
    inspectedComponent: "Component selector",
    expression: "Calculated value",
    label: "Label",
    materials: "Materials select",
    number: "Number",
    select: "Select",
    severities: "Severity criteria select",
    text: "Text",
    textArea: "TextArea",
  },
  property: {
    description: "Description",
    fieldType: "Field type",
    hint: "Hint",
    label: "Label",
    max: "Maximum",
    min: "Minimum",
    model: "Model key",
    placeholder: "Placeholder",
    precision: "Number of decimals",
    rows: "Number of rows",
    unit: "Unit",
  },
  conditions: {
    title: "Visibility conditions",
    rowTitle: "Visibility condition {{index}}",
    add: "Add visibility condition",
    delete: "Delete visibility condition",
    tooltip:
      "Field will be visible if any of the following conditions are true.",
    model: {
      placeholder: "Field",
      missing: "Please select a field",
    },
    operator: {
      placeholder: "Operator",
      missing: "Please select an operator",
    },
    value: {
      placeholder: "Value",
      missing: "Please enter a value",
    },
  },
  select: {
    title: "Select list's values",
    add: "Add a new set of values",
    delete: "Delete set of values",
    tooltip:
      "A set of values becomes visible in the list as soon as at least one of its visibility conditions is met.",
    values: {
      label: "Set of values {{index}}",
      missing: "Please add at least one set of values.",
    },
    copy: {
      tooltip: "Copy the values",
      message: "Values copied to clipboard!",
    },
  },
  expression: {
    label: "Mathematical formula",
    placeholder:
      "Enter a formula ex: 2.54 * sqrt((ax - bx)^2 (ay - by)^2 (az-bz)^2)",
    hint: {
      1: "Supported operations: <strong>+ - * / ^</strong> (exponent) <strong>sqrt</strong>(expression)",
      2: "Variables: You can use letters and underscores, e.g.: <strong>a b temp_celsius</strong>",
      3: "Constants: You can use an integer, a decimal, or a fraction, e.g.: <strong>10 3.141 5/7</strong>",
    },
    variables: {
      title: "Assigning variables",
      placeholder: "Numeric field of the form",
      requiredError: "Please select a numeric field",
    },
  },
};
